import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { DecorationSet } from '@tiptap/pm/view';

export const readableInkKey = new PluginKey<DecorationSet>('readableInk');

// Decorations are presentation only: ProseMirror owns their DOM and never serializes them.
export const ReadableInk = Extension.create({
  name: 'readableInk',
  addProseMirrorPlugins() {
    return [new Plugin<DecorationSet>({
      key: readableInkKey,
      state: {
        init: () => DecorationSet.empty,
        apply: (transaction, current) => transaction.getMeta(readableInkKey) ?? current.map(transaction.mapping, transaction.doc),
      },
      props: { decorations: state => readableInkKey.getState(state) },
    })];
  },
});
